module.exports = __webpack_public_path__ + "static/media/check-example.f9650b90.svg";